const LoadingSquiggle = () => (
  <div className="flex items-center justify-center h-screen">
    <svg
      width="54"
      height="22"
      viewBox="0 0 27 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 8.08974C1.5 8.09883 2.41247 7.42625 4.83446 5.867C6.30446 4.92063 8.42286 3.9188 9.6462 3.31368C11.1591 2.56532 11.6719 2.45236 12.0431 2.41756C12.4159 2.38263 12.8173 2.55214 13.2025 2.82131C14.1171 3.46044 13.714 5.3073 13.2343 7.71686C13.12 8.2907 13.1213 8.71276 13.2282 8.98753C13.3351 9.26231 13.567 9.38056 13.9352 9.39434C14.8039 9.42687 16.1156 8.7848 18.4436 7.16603C19.9692 5.97921 22.1939 4.05064 23.4672 2.96416C24.7404 1.87767 24.9948 1.69172 25.2569 1.50012"
        stroke="#7581BD"
        strokeWidth="3"
        strokeLinecap="round"
        style={{
          strokeDasharray: 50,
          strokeDashoffset: 50,
          animation: 'drawSquiggle 1s ease-in-out infinite alternate',
        }}
      />
      <style>{`
        @keyframes drawSquiggle {
          to {
            stroke-dashoffset: 0;
          }
        }
      `}</style>
    </svg>
  </div>
);

export default LoadingSquiggle;
